var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_37818",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4e90fa",
    floodOpacity: 0.447
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(11100 16484)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -11100, -16484)",
    filter: "url(#Ellipse_37818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37818-2",
    "data-name": "Ellipse 37818",
    cx: 41,
    cy: 41,
    r: 41,
    transform: "translate(15 12)",
    fill: "#4e90fa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_858292",
    "data-name": "Path 858292",
    d: "M17.8,13.8V3.8a2,2,0,1,0-4,0v10H3.8a2,2,0,1,0,0,4h10v10a2,2,0,1,0,4,0v-10h10a2,2,0,1,0,0-4Z",
    transform: "translate(-11059.8 -16446.801)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.2575eefb611b334348fd26baffc84cec.svg";
export { ForwardRef as ReactComponent };